import React from "react";
// import { Menu } from "antd";
// import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
// import { reducer, initialState } from "../hooks/modalReducer";

import {
  Tabel,
  // DropDown,
  // DropDownMenu,
  // Modal,
  FilterWraper,
  Badge,
} from "../core";
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");
const columns = [
  {
    title: "SR #",
    dataIndex: "SNo",
    key: "S.No",
    render: (text, record, index) => <span>{index + 1}</span>,
    width: 150,
  },
  {
    title: "Contract #",
    dataIndex: "contract_no",
    key: "contract_no",
    width: 150,
  },
  {
    title: "Date",
    dataIndex: "payment_date",
    key: "payment_date",
    render: (text, record, index) => {
      return (
        <span>
          {/* {record.invoice_date}
          <br /> */}
          {CHANGE_DATE_FORMAT.changeDateFormat(record.payment_date)}
        </span>
      );
    },
    width: 150,
  },
  {
    title: "Amount",
    dataIndex: "payment_amount",
    key: "payment_amount",
    width: 150,
  },
  {
    title: "Payment Status",
    dataIndex: "payment_option",
    key: "payment_option",
    render: (text) => <Badge status={text} text={text}></Badge>,
    width: 150,
  },
  // {
  //   title: "",
  //   dataIndex: "action",
  //   width: 150,
  //   render: (text, record, index) => (
  //     <DropDown
  //       overlay={<MenuCompo index={index} record={record} />}
  //       record={record}
  //     />
  //   ),
  // },
];
const ContractInfo = ({ className, ...rest }) => {
  const payments = useSelector((state) => state.addBuyer.buyer_payments);

  const [BuyerPayments, setBuyerpayment] = React.useState(null);
  React.useEffect(() => {
    setBuyerpayment(payments);
  }, [payments]);
  const dateRange = (date, dateString) => {
    let min = dateString[0];
    let max = dateString[1];
    console.log(min, max);

    const filteredArray = payments.filter((record) => {
      return record.payment_date >= min && record.payment_date <= max;
    });

    setBuyerpayment(min && max ? filteredArray : payments);
  };
  const changeInput = (e) => {
    let buyerName = e.target.value;

    const filteredArray = payments.filter((record) => {
      return record.contract_no.indexOf(buyerName) > -1;
    });
    setBuyerpayment(filteredArray);
  };
  return (
    <FilterWraper
      rangeFilter={dateRange}
      inpputChange={changeInput}
      dropDown={false}
      range={true}
    >
      <Tabel columns={columns} data={BuyerPayments} {...rest} />
    </FilterWraper>
  );
};
// const MenuCompo = (params) => {
//   const [state, dispatch] = React.useReducer(reducer, initialState);
//   const oK = () => {};
//   function menuClickHandler({ key }) {
//     return key === "delete"
//       ? dispatch({
//           type: "MODAL_VIEW",
//           payload: { flag: true, modal_name: key },
//         })
//       : null;
//   }
//   // const { record } = params;
//   return (
//     <DropDownMenu onClick={menuClickHandler}>
//       <Modal
//         closable={true}
//         visible={state.visible}
//         // onCreate={onCreate}
//         okText="Yes"
//         onOk={oK}
//         maxwidth="550px"
//         cancelText="No"
//         onCancel={(e) => {
//           e.stopPropagation();
//           dispatch({ type: "MODAL_VIEW", payload: false });
//         }}
//         tittle="Are You Sure you want to delete this record"
//       ></Modal>
//       <Menu.Item key="delete" color="blue">
//         Delete
//       </Menu.Item>
//       <Menu.Item>
//         {/* <Link to={`/buyer-list/${record.buyer_name}`}>View List</Link> */}
//         view list
//       </Menu.Item>
//       <Menu.Item>Edit</Menu.Item>
//     </DropDownMenu>
//   );
// };
export default ContractInfo;
